import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../ui/Button';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full px-6 py-8">
        <div className="text-center">
          <h1 className="text-9xl font-bold text-gray-300">404</h1>
          <h2 className="mt-4 text-3xl font-semibold text-gray-900">
            Página não encontrada
          </h2>
          <p className="mt-2 text-lg text-gray-600">
            Desculpe, não conseguimos encontrar a página que você está procurando.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <Button
              onClick={() => navigate(-1)}
              variant="secondary"
            >
              Voltar
            </Button>
            <Button
              onClick={() => navigate('/dashboard')}
              variant="primary"
            >
              Ir para Dashboard
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;